import script from "./EditCompanyEmailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditCompanyEmailModal.vue?vue&type=script&setup=true&lang=js"

import "./EditCompanyEmailModal.vue?vue&type=style&index=0&id=5207f73a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5207f73a"]])

export default __exports__